export default {"src":"/_next/static/image/public/images/flags/flag_1868.da6cd479c8ba77ed6b83a81f958ae6fd.svg","height":16,"width":24};